<template>
  <div id="app">
    <div id="vipOpenButton" style="display:block" >
        <div class="vip-center">
          <button @click="toPay">立即免费下载</button>
          <div class="vip-img"></div>
          <!-- <img src="./img/down-desc.png" alt /> -->
        </div>
      </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
import foot from "./channelFoot";

//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";

export default {
  name: "app",
  metaInfo: {
    title: "好运吧"
  },
  data() {
    return {
      msg: "渠道推广",
      btnText: "发送验证码",
      from: {
        mobile: "",
        code: "",
        shareType: 1,
        shareId: null
      },
      unimgSrc: require("./img/login-disagree.png"),
      imgSrc: require("./img/loggin-agree.png"),
      closeSrc: require("../../assets/img/close@2x.png"),
      imgFlag: true,
      codeshow: true,
      btnDisabled: false,
      btnDisabled: false,
      tuicode: "",
      codeimg: "",

      cid: ""
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var channelId = this.$route.params.channelId;
    var type = this.$route.params.type;
        console.log("type:" + type);

    if (type == 1) {
      this.imgFlag = false;
    }

    console.log("sharchannelIdeid:" + channelId);
    // this.type =type;
    // this.shareid =shareid;
    // if(!util.isNum(this.channelId)){
    //     tips.toast("地址不合法")
    //     this.$router.push("/index");
    // }
    store.commit(types.SET_CHANNEL, channelId);
    this.cid = channelId;
    setTimeout(() => {
          // console.log('修改显示')
          //$('#vipOpenButton').css('display','block');
    }, 1000);
  },
  methods:{
    toPay() {
      this.$point.eventtag(this.userid, "btn_100008");
      var ua = window.navigator.userAgent.toLowerCase();

      if (/(Android)/i.test(navigator.userAgent)) {
        this.$point.eventuid(
          "down_app_a_" + this.cid,
          this.userid,
          "down_app"
        );
        //下载
        window.location.href = "http://wap.haoyunba.com/apk/clac/" + this.cid+"_sign.apk";

      } else {
          this.$point.eventtag(
          "down_app_o_" + this.cid,
          "down_app"
        );
        //window.location = "https://apps.apple.com/cn/app/id1502944777";
        //使用企业签签名作为下载的标识
       
          // console.log(" 渠道地址：cid："+store.state.mutations.channel)
          //  //使用企业签签名作为下载的标识
            setTimeout(() => {
              this.$router.push("/iosSetting");
            }, 2000);

            window.location.href =
              "itms-services://?action=download-manifest&url=https://www.haoyunba.com/h5/ios/clac/manifest.plist";

      }
        
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>

#vipOpenButton {
  position: fixed;
  display: block;
  left: 0;
  bottom: 0;
  width: 100%;
}



.vip-center {
  width: 100%;
  height: 100%;
  text-align: center;
}

.vip-center img {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 260px;
  margin: 0 0 50px 450px;
}

.vip-img{
   position: fixed;
  left: 0;
  bottom: 0;
  width: 160px;
  height: 40px;
  margin: 0 0 50px 450px;
  background: url('./img/down-desc.png');
  background-size: 100% 100%;
}

.vip-center span {
  width: 100%;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #f5bfab;
  line-height: 76px;
}
.vip-center button {
  width: 100%;
  height: 100px;
  background: linear-gradient(
    90deg,
    rgba(238, 176, 142, 1) 0%,
    rgba(249, 220, 193, 1) 100%
  );
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  border: none;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/channel/channelFoot.vue